import { createAction } from '@reduxjs/toolkit'
import type { ClipboardType } from './reducer'
import { ActionType } from './actionTypes'
import { DisableEditorState, EditorUIState, CanvasInteractionState } from '@/constants/app-options'
import { LoaderTextAnimationType } from '@/constants/app-options'

export const setZoomRatio = createAction<number>('editor/setZoomRatio')
export const setIsOpenErrorModalRemoveBg = createAction<boolean>('editor/setIsOpenErrorModalRemoveBg')
export const setHasClipboardImage = createAction<ClipboardType>('editor/setHasClipboardImage')
export const setCallbackFromCreationPage = createAction<{
  action: ActionType
  value?: any
  analytic?: any
}>('editor/setCallbackFromCreationPage')
export const setDisableEditorState = createAction<DisableEditorState>('editor/setDisableEditorState')
export const setEditorState = createAction<EditorUIState>('editor/setEditorState')
export const setIsOpenInspector = createAction<boolean>('editor/setIsOpenInspector')
export const setLoaderText = createAction<{ texts: string[]; style?: 'gradient'; minWidth?: string; animationType?: LoaderTextAnimationType | null } | null>('editor/setLoaderText')
export const setCanvasInteractionState = createAction<CanvasInteractionState>('editor/setCanvasInteractionState')
